import UserTypeGetter from "@/data/userTypes/UserTypeGetter";

export default {
    intro:          state => state.intro,
    user:           state => state.user,

    isUserStudent:  state => state.user.type.includes('student'),

    members:        state => state.members.sort((x, d) => {
        const slugA = x.slug.toLowerCase()
        const slugB = d.slug.toLowerCase()

        return slugA < slugB ? -1 : 1
    }),

    color: (state) => {
        const { type } = state.user
        return UserTypeGetter.getType(type).color
    },

    eContentLink: (state) => {
        const { type } = state.user
        return UserTypeGetter.getType(type).eContent.link
    },

    eContentLabel: (state) => {
        const { type } = state.user
        return UserTypeGetter.getType(type).eContent.label
    },
}
